export default __webpack_public_path__ + "static/homeland-1637b7bbc3ec5e18cfb04185cf3802e9.png";